import { useMsal } from '@azure/msal-react';

const useIsAdmin = () => {
  const { accounts } = useMsal();

  const userRoles = accounts[0]?.idTokenClaims?.roles || [];
  const adminRoles = ['OSEP.Generator.Admin', 'OSEP.Admin'];
  const isAdmin = userRoles.some((role) => adminRoles.includes(role));

  return { isAdmin };
};

export default useIsAdmin;
